import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { H3, H4 } from '../../../styles/FontStyles';
import {
  ArrowChevron,
  Button,
  Collapsable,
  Flexed
} from '../../../styles/GlobalComponents';

import { CaptionText, P1, P3 } from '../../../styles/FontStyles';
import { color } from '../../../styles/GlobalStyles';
import { Icon, IconPortfolioOrders } from '../../../styles/Icons';
import { BoxPortfolio, SummaryGrid } from '../Portfolio.styled';

import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { useAppSelector } from '../../../app/hooks';
import { formatUSD } from '../../../helpers/helperFunctions';
import { POWERPACKS } from '../../../routes/routes';
import Spinner from '../../../components/common/Spinner';

import { PortfolioPowerPacksItem } from './PortfolioPowerPacksItem';
import { PackageTrading, UserPackage } from '../Portfolio.types';

export const PowerPacksSummary = ({
  setIsOpen
}: {
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const dispatch = useDispatch();

  const ref = useRef<any>(null);
  const [expanded, setExpanded] = useState(true);
  const [packageItem, setPackageItem] = useState<
    UserPackage | PackageTrading | null
  >(null);
  const history = useHistory();
  const [height, setHeight] = useState(ref?.current?.clientHeight);
  const { powerPackPackages, loadingSummary } = useAppSelector(
    (state) => state.portfolio
  );

  return (
    <div style={{ marginBottom: 40 }}>
      <Flexed mb='20' center between>
        <H3>My Power Pack summary</H3>
      </Flexed>

      <SummaryGrid>
        <BoxPortfolio>
          <Icon mr='16' mrSM='8' color={color.colors.secondary100}>
            <IconPortfolioOrders />
          </Icon>
          <div>
            <CaptionText caps bold color={color.colors.neutral500} mb='10'>
              Total Power Pack Orders
            </CaptionText>

            <P1 bold flex alignEnd gap='5px'>
              {formatUSD(powerPackPackages?.summary?.totalOrderAmount)}
              <P3 mb='1'>USDT</P3>
            </P1>
          </div>
        </BoxPortfolio>
      </SummaryGrid>

      <div style={{ position: 'relative' }}>
        {loadingSummary && <Spinner absolute transparent />}
      </div>

      <Flexed center between wrap>
        <Flexed
          mb='20'
          center
          gap='20px'
          pointer
          onClick={() => setExpanded(!expanded)}>
          <H4>My Power Packs</H4>
          <ArrowChevron direction={expanded ? 'up' : 'down'} />
        </Flexed>

        <Button
          negative
          maxWidth='350px'
          maxWidthSM='100%'
          onClick={() => history.push(POWERPACKS)}>
          ADD MORE POWER PACKS
        </Button>
      </Flexed>

      <Collapsable expanded={expanded} elementHeight={height}>
        <div ref={ref}>
          {powerPackPackages?.userPackages?.map((item: any, i: number) => (
            <PortfolioPowerPacksItem
              key={i}
              item={item}
              setPackageItem={setPackageItem}
              setIsOpen={setIsOpen}
            />
          ))}
        </div>
      </Collapsable>
    </div>
  );
};
